module.exports = __webpack_public_path__ + "img/84.9.TU.ba7a4f06.png";